export default __webpack_public_path__ + "static/media/nft_icon.85f106fa.png";